import { render, staticRenderFns } from "./HeadlineTitle.vue?vue&type=template&id=7515cbec"
import script from "./HeadlineTitle.vue?vue&type=script&lang=ts"
export * from "./HeadlineTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineTitle.vue?vue&type=style&index=0&id=7515cbec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/streams-schedule/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports